import api from "./api";

const controller = "usuarios";

export const getUsuarioById = (id: any) =>
  api.post<any>(`api/${controller}/`, { id });

export const createUsuario = (data: any) =>
  api.post<any>(`api/${controller}/create`, data);

export const getAllUsuarios = () =>
  api.get<any>(`api/${controller}/getAllUsuarios`);
